

<script>
export default class ImageLoadCounter{
  constructor(_imgsToLoad) {
    //will be incremented with every image loaded
    this.imgsloaded = 0;
    //images to load
    this.imgsToLoad = _imgsToLoad;
  }
}
</script>

